.firstItemFocusTarget {
  display: var(--haus-productList__firstItemFocusTarget__display, block);

  &:focus-visible,
  &:focus {
    outline: var(--haus-productList__firstItemFocusTarget__outline, 2px solid currentColor);
    outline-offset: var(--haus-productList__firstItemFocusTarget__outlineOffset, 2px);
  }
}

.productList {
  display: var(--haus-productList__productList__display, grid);
  scroll-margin-top: var(--haus-productList__productList__scroll-margin-top, 60px);
  grid-template-columns: var(
    --haus-productList__productList__grid-template-columns,
    repeat(auto-fill, minmax(250px, 1fr))
  );
  gap: var(
    --haus-productList__productList__gap,
    var(--haus-spacing-xl, 48px) var(--haus-spacing-md, 24px)
  );
  position: var(--haus-productList__productList__position, relative);
  z-index: var(--haus-productList__productList__z-index, 2);
}

.noProducts .error,
.spinner {
  display: var(--haus-productList__spinner__display, flex);
  justify-content: var(--haus-productList__spinner__justify-content, center);
  align-items: var(--haus-productList__spinner__align-items, center);
  height: var(--haus-productList__spinner__height, 100%);
}

.noProducts p {
  color: var(--haus-productList__noProducts__color, var(--haus-color-primary, #003a70));
}

.error p {
  color: var(--haus-productList__error__color, var(--haus-color-error, #e53e3e));
}
